import { useTheme } from "styled-components";
import { useMemo } from "react";
const colorNameMap = {
    neutral: "Value",
    good: "Green",
    bad: "Red",
    average: "Yellow",
};
export default (status) => {
    const { colors } = useTheme();
    return useMemo(() => (status &&
        colorNameMap[status] && {
        color: colors[`apolloColorViz${colorNameMap[status]}`],
        textColor: colors[`apolloColorTextViz${colorNameMap[status]}`],
    }) || { color: colors.apolloColorVizValue, textColor: colors.apolloColorTextVizValue }, [status]);
};
//# sourceMappingURL=useStatusColor.js.map